// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'temp-parts';

const Model = class TempPart extends BaseModel {
  static modelName = 'TempPart';

  static instanceDefaults() {
    return {
      tempRfqId: {},
      csiRfqId: '',
      csiLineNumber: '',
      isCsi: false,
      CustItemName: '',
      Material: '',
      MaterialSeries: '',
      MaterialThickness: '',
      MaterialFinish: '',
      MaterialFinishOption: '',
      RawMaterial: '',
      DrawingRowPointer: '',
      DrawingNumber: '',
      AnalysisResult: {
        manufacturability: {},
        cutting: {},
        nesting: {},
      },
      CsiAnalysisData: [],
      ReqQty: 1,
      EstimateLineStatus: {
        isDrawingUploaded: false,
        isDrawingUploadedMsg: '',
        isManufacturable: false,
        isManufacturableMsg: '',
        isCalculatingCutting: false,
        isCuttingCalculated: false,
        isCuttingCalculatedMsg: '',
        isCalculatingNesting: false,
        isNestingCalculated: false,
        isNestingCalculatedMsg: '',
        isAnalysed: false,
        isAnalysedMsg: '',
        isFinishSelected: false,
        isFinishSelectedMsg: '',
        isThumbnailUploaded: false,
        isThumbnailUploadedMsg: '',
        isObjUploaded: false,
        isObjUploadedMsg: '',
        isDxfUploaded: false,
        isDxfUploadedMsg: '',
      },
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
